import pako from 'pako';

// Gzip压缩 + Base64编码
export function gzipToBase64(str) {
  // 将字符串转换为Uint8Array
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  
  // 使用pako进行gzip压缩
  const compressed = pako.gzip(data);
  
  // 将压缩数据转换为Base64字符串
  const binaryString = String.fromCharCode(...compressed);
  return btoa(binaryString);
}

export function encodeParam(value) {
  // 1. GZIP 压缩
  const compressed = pako.gzip(value);
  
  // 2. Base64 编码
  const base64 = btoa(String.fromCharCode(...compressed));
  
  // 3. URL 编码
  return encodeURIComponent(base64);
}
export async function o(e) {
  (e = new TextEncoder().encode(e)),
    (e = new Response(
      new Blob([e]).stream().pipeThrough(new CompressionStream('gzip'))
    ).arrayBuffer()),
    (e = new Uint8Array(await e))
  return btoa(String.fromCharCode(...e))
}
// Base64解码 + Gzip解压
export function base64ToGunzip(base64Str) {
  // Base64解码
  const binaryString = atob(base64Str);
  const charCodes = new Uint8Array(binaryString.length);
  
  for (let i = 0; i < binaryString.length; i++) {
    charCodes[i] = binaryString.charCodeAt(i);
  }
  
  // 使用pako解压
  const decompressed = pako.ungzip(charCodes);
  
  // 将Uint8Array转换回字符串
  const decoder = new TextDecoder();
  return decoder.decode(decompressed);
}